var $ = jQuery;
/*
 * Variables
 */
var $apiUri = '/api/';
var animate_prefix = '';

var $btnScrollTop = ['<a href="#" class="scrollToTop" title="Scroll to top"></a>'];
var $btnScrollTopSelector = '.scrollToTop';

var dtb_language = {
	decimal:			"",
	emptyTable:			"Keine Daten in Tabelle verfügbar",
	info:				"_START_ bis _END_ von _TOTAL_ Einträgen anzeigen",
	infoEmpty:			"0 bis 0 von 0 Einträgen anzeigen",
	infoFiltered:		"(gefiltert aus _MAX_ Gesamteinträgen)",
	infoPostFix:		"",
	thousands:			",",
	lengthMenu:			"_MENU_ Einträge anzeigen",
	loadingRecords:		"Loading...",
	processing:			"Processing...",
	search:				"Suche:",
	zeroRecords:		"Keine übereinstimmenden Datensätze gefunden",
	paginate: {
		first:			'<i class="fas fa-angle-double-right"></i>',
		last:			'<i class="fas fa-angle-double-left"></i>',
		next:			'<i class="fas fa-angle-right"></i>',
		previous:		'<i class="fas fa-angle-left"></i>'
	},
	aria: {
		sortAscending:	": aktivieren, um die Spalte aufsteigend zu sortieren",
		sortDescending:	": aktivieren, um die absteigende Spalte zu sortieren"
	}
};
